import React, { useState } from "react";
import { db } from "../firebase"; // adjust path if needed
import { doc, setDoc } from "firebase/firestore";
import Navbar from "../components/AgentNavbar";
import { v4 as uuidv4 } from "uuid";

export default function AddAgent() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  // simple random password generator (optional)
  const generatePassword = () => {
    const newPassword = Math.random().toString(36).slice(-8);
    setPassword(newPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert("Username and password are required.");
      return;
    }

    try {
      // Save to Firestore under users/{username}
      await setDoc(doc(db, "agents", username), {
        username,
        password,
        role: "agent",
      });

      setIsSaved(true);
      setUsername("");
      setPassword("");
    } catch (err) {
      console.error("Error adding agent:", err);
      alert("Failed to add agent.");
    }
  };

  return (
    <div
      style={{
        maxWidth: "450px",
        margin: "2rem auto",
        padding: "2rem",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Navbar />
      <h2 style={{ fontSize: "1.5rem", marginBottom: "1.5rem" }}>Add New Agent</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "1rem" }}>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "500" }}>
            Username
          </label>
          <input
            type="text"
            placeholder="Enter agent username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{
              width: "100%",
              padding: "0.75rem",
              border: "1px solid #ccc",
              borderRadius: "8px",
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: "500" }}>
            Password
          </label>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <input
              type="text"
              placeholder="Enter or generate password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                flex: 1,
                padding: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
              required
            />
            <button
              type="button"
              onClick={generatePassword}
              style={{
                padding: "0.75rem 1rem",
                background: "#1e1eaa",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Generate
            </button>
          </div>
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "0.9rem",
            background: "#1e1eaa",
            color: "#fff",
            fontWeight: "500",
            fontSize: "1rem",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Save Agent
        </button>
      </form>

      {isSaved && (
        <p style={{ marginTop: "1rem", color: "green", fontWeight: "500" }}>
          ✅ Agent added successfully!
        </p>
      )}
    </div>
  );
}
